import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import "../index.css"

import { Button, CheckboxField, Table } from '../../../../helpers'
import { RadioButton } from 'primereact/radiobutton'
import { Dialog } from 'primereact/dialog'

import GSTINsStatusChange from './GSTINsStatusChange'
import UnupdatedGSTINs from './UnupdatedGSTINs'
import ViewGSTINBillAddrs from './ViewGSTINBillAddrs'

import Loading from '../../../../common/Loading'

import { raiseToast } from '../../../../services/redux/reducers/toast/toast'
import { fetchStatus } from '../../../../services/redux/reducers/commonThunk'

import { updateCompanyGSTINsStatus } from '../../../../services/api/companyGSTINs'
import { updateCompanyPrimaryGSTIN } from '../../../../services/api/company'


const ViewGSTINs = (props) => {
    
    const { id } = useParams()
    const dispatch = useDispatch()

    const {
        gstinData,
        companyGSTIN,
        billingAddress,
        companyDetails,
        editedCompanyDetails,
        visibleViewGSTINs,
        setVisibleViewGSTINs,
        setEditedCompanyGSTIN
    } = props

    const [selectedGSTINs, setSelectedGSTINs] = useState([])
    const [visibleGSTINBillAddrs, setVisibleGSTINBillAddrs] = useState(false)
    const [selectedGSTINBillAddrs, setSelectedGSTINBillAddrs] = useState([])
    const [isEditing, setIsEditing] = useState(false)
    const [visibleGSTINStatusChange, setVisibleGSTINStatusChange] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [visibleUnupdatedGSTINs, setVisibleUnupdatedGSTINs] = useState(false)
    const [unupdatedGSTINs, setUnupdatedGSTINs] = useState([])

    const statuses = useSelector(state => state.common.status)
    const loggedInUserId = useSelector(state => state.userDetails.userId)    

    useEffect(() => {
        dispatch(fetchStatus())
    }, [])

    const handleRowSelection = (event, row) => {
        let relatedGSTINs = []
        if(selectedGSTINs.includes(row)){
            relatedGSTINs = selectedGSTINs.filter(eachGSTIN => eachGSTIN.gstinCode === row.gstinCode ? false : true)
        }else{
            relatedGSTINs = [...selectedGSTINs, row]
        }

        setSelectedGSTINs(relatedGSTINs)
	}

    const selectAllGSTINs = (event) => {
            let relatedGSTINs = []
            if(event.checked){
                relatedGSTINs = [...gstinData]
            }
            setSelectedGSTINs(relatedGSTINs)
        }

    const getHeaderCheckbox = () => {
            return (
                <div className="">
                    <CheckboxField onChange={(e) => selectAllGSTINs(e)} checked={gstinData.length && selectedGSTINs.length === gstinData.length} />
                </div>
            )
        }

    const selectCheckBoxBody = (row) => {
        return (
            <div className={`flex justify-content-center`}>
                <CheckboxField checked={selectedGSTINs.includes(row)} onChange={(e) => handleRowSelection(e, row)} />
            </div>
        )
    }

    const gstinCodeBody = (row) => {
        if(row.gstinCode){
            return row.gstinCode
        }

        return "-"
    }

    const tradeNameBody = (row) => {
        if(row.gstinTradeName){
            return row.gstinTradeName
        }

        return "N/A"
    }

    const lastFilingDateBody = (row) => {
        if(row.lastFilingDate){
            return moment(row.lastFilingDate).format("DD MMM YYYY")
        }

        return "N/A"
    }

    const getStatusColor = (statusId) => {
		if ([2, 20].includes(statusId)) {
			return '#F1592A'
		} else if ([21, 22].includes(statusId)) {
			return '#cfbf32'
		} else {
			return '#13A89D'
		}
	}

    const gstinStatusBody = (row) => {
		const relatedStatus = statuses.find((eachStatus) => eachStatus.statusId === row.statusId)
		const statusColor = getStatusColor(row.statusId)

        if(relatedStatus){
            return (
                <span style={{ color: statusColor, fontWeight: 'bold' }}>
                    {relatedStatus.status}
                </span>
            )
        }

        return "N/A"
    }

    const billingAddressBody = (row) => {
        const filteredAddress = billingAddress.filter(
            (eachAddress) => eachAddress.gstinCode === row.gstinCode
        )

        return (
            <Button label="View" className="small-btn" onClick={() => handleOnclickViewBillAddrs(filteredAddress)} />            
        )

    }

    const lastUpdatedDateBody = (row) => {
        if(row.updatedAt){
            return moment(row.updatedAt).format("DD MMM YYYY")
        }

        return "N/A"
    }

    const handleOnchangePrimaryGSTIN = (row) => {
        // props.setEditedCompanyDetails({ ...editedCompanyDetails, gstinCode: row.gstinCode })
        handleUpdateCompanyPrimaryGSTIN(row.gstinCode)
    }

    const handleUpdateCompanyPrimaryGSTIN = async (primaryGSTIN) => {
        let data = {
            companyId: id,
            primaryGSTIN: primaryGSTIN
        }

        const selectedGSTIN = gstinData.find(eachGSTIN => eachGSTIN.gstinCode === primaryGSTIN)
        if (selectedGSTIN && selectedGSTIN.statusId !== 1){
            return dispatch(raiseToast({ severity: 'warn', detail: "Only Active GSTINs can be selected as primary GSTIN." }))
        }        

        if (window.confirm("Are you sure you want change primary GSTIN")) {
            setIsLoading(true)
            const updateCompanyPrimaryGSTINRes = await updateCompanyPrimaryGSTIN(data)
            setIsLoading(false)

            if (updateCompanyPrimaryGSTINRes?.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: updateCompanyPrimaryGSTINRes?.data?.error, life: 3000 }))
            } 

            props.setEditedCompanyDetails({ ...editedCompanyDetails, gstinCode: updateCompanyPrimaryGSTINRes.data.gstinCode })
            dispatch(raiseToast({ severity: 'success', detail: "Primary GSTIN changed successfully" }))

        }
    }
    
    const primaryGSTINBody = (row) => {
        return(
            	<div style={{ textAlign: 'center' }}>
            		<RadioButton
            			type="radio"
            			name="gstinSelect"
            			checked={row.gstinCode === editedCompanyDetails.gstinCode}
            			// disabled={!isEditing}
            			onChange={() => handleOnchangePrimaryGSTIN(row)}
            		/>
            	</div>
        )
    }

    const tableColumns = [
        {
            header: getHeaderCheckbox,
            body: selectCheckBoxBody,
        },
        {
            header: 'GSTIN Code',
            field: 'gstinCode',
            body: gstinCodeBody
        },
        {
            header: 'Trade Name',
            field: 'gstinTradeName',
            body: tradeNameBody
        },
        {
            header: 'Last Filing Date',
            field: "lastFilingDate",
            body: lastFilingDateBody
        },
        {
            header: 'Status',
            field: "",
            body: gstinStatusBody
        },
        {
            header: 'Billing Address',
            field: "",
            body: billingAddressBody,
        },
        {
            header: 'Last Updated date',
            field: "updatedAt",
            body: lastUpdatedDateBody,
        },
        {
            header: 'Primary GSTIN',
            body: primaryGSTINBody
        },
    ]

    const saveStatusChange = async (gstinStatus) => {
        if (!gstinStatus) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select GSTIN status." }))
        }
        const selectedGSTINCodes = selectedGSTINs.map(eachRow => eachRow.gstinCode)
        const selectedGSTINStatus = statuses.find(eachStatus => eachStatus.status === gstinStatus)
        const requestBody = {
            gstins: selectedGSTINCodes,
            status: gstinStatus,
            userId: loggedInUserId,
            remarks: "",
        }

        setIsLoading(true)
        const response = await updateCompanyGSTINsStatus(requestBody)
        setIsLoading(false)
        console.log("GSTIN status update response:", response)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error }))
        } else {
            const { companyGSTINsWithUpdatedStatus, newGSTINStatusLogs} = response.data

            const unupdatedGSTINsList = companyGSTINsWithUpdatedStatus.filter(eachUpdatedGSTIN => eachUpdatedGSTIN.statusId !== selectedGSTINStatus.statusId)

            let updatedGSTINs = []
            
            gstinData.map(eachGSTIN => {
                const relatedCompanyGSTINResponse = companyGSTINsWithUpdatedStatus.find(eachCompanyGSTINWithUpdatedStatus => eachCompanyGSTINWithUpdatedStatus.gstinCode === eachGSTIN.gstinCode)
                if (relatedCompanyGSTINResponse){
                    eachGSTIN = {...eachGSTIN, statusId: relatedCompanyGSTINResponse.statusId}
                }

                updatedGSTINs.push(eachGSTIN)
            })

            setEditedCompanyGSTIN(updatedGSTINs)
            setSelectedGSTINs([])
            if (unupdatedGSTINsList.length > 0) {
                setUnupdatedGSTINs(unupdatedGSTINsList)
                setVisibleUnupdatedGSTINs(true)
            } else {
                dispatch(raiseToast({ severity: 'success', detail: "All GSTIN statuses updated successfully." }))
            }
        }
        setVisibleGSTINStatusChange(false)
    }

    const handleDiscardGSTINsChanges = () => {
        if(window.confirm("Are you sure you want to discard the changes")){
            // setIsEditing(false)
            setSelectedGSTINs([])
            setSelectedGSTINBillAddrs([])
            setVisibleGSTINBillAddrs(false)
            props.setEditedCompanyDetails({...editedCompanyDetails, gstinCode: companyDetails.gstinCode})
            props.setEditedCompanyGSTIN([...companyGSTIN])
        }
    }

    const handleOnclickViewBillAddrs = (filteredAddresses) => {
        setSelectedGSTINBillAddrs(filteredAddresses)
		setVisibleGSTINBillAddrs(true)
    }

    const handleCloseGSTINBillAddrs = () => {
        setVisibleGSTINBillAddrs(false)
		setSelectedGSTINBillAddrs([])
    }

    const handleCloseGSTINStatusChange = () => {
        setVisibleGSTINStatusChange(false)
    }

    const handleOnclickChangeStatus = () => {
        if (!selectedGSTINs.length) {
            return dispatch(raiseToast({ severity: 'warn', detail: "Please select at least one GSTIN"}))
        }
        setVisibleGSTINStatusChange(true)
	}

    const sortedGSTINs = gstinData.sort((a, b) => a.gstinCode - b.gstinCode)
    
    return (
        <div>
            <Dialog header={"Company GSTINs"} style={{ width: '80vw', minHeight: "35%" }} visible={visibleViewGSTINs} onHide={() => setVisibleViewGSTINs(false)}>
                <div className="flex justify-content-end mb-2">
                    <div>
                        <Button className="small-btn" label="Change Status" onClick={handleOnclickChangeStatus} disabled={!selectedGSTINs.length} permissions={[262]} />
                    </div>
                    {/* {
                        isEditing ?
                            <div>
                                <Button className="small-btn discard-btn" style={{ marginRight: "10px" }} label="DISCARD" onClick={handleDiscardGSTINsChanges} />
                                <Button className="small-btn" label="Change Status"onClick={handleOnclickChangeStatus} />
                            </div>
                            :
                            <div>
                                <Button className="small-btn" style={{ marginRight: '10px' }} label="EDIT" onClick={() => setIsEditing(true)} />
                            </div>
                    } */}
                </div>
                <div className="followup-table" style={{ order: "1", width: "100%" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table
                                tableColumns={tableColumns}
                                data={sortedGSTINs}
                                scrollable={"true"}
                                scrollHeight="450px"
                                loading={false}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
            <GSTINsStatusChange 
                visibleGSTINStatusChange={visibleGSTINStatusChange}
                setVisibleGSTINStatusChange={setVisibleGSTINStatusChange}
                handleCloseGSTINStatusChange={handleCloseGSTINStatusChange}
                saveStatusChange={saveStatusChange}
            />
            <UnupdatedGSTINs 
                unupdatedGSTINs={unupdatedGSTINs}
                visibleUnupdatedGSTINs={visibleUnupdatedGSTINs}
                setVisibleUnupdatedGSTINs={setVisibleUnupdatedGSTINs}
            />
            <ViewGSTINBillAddrs 
                visibleGSTINBillAddrs={visibleGSTINBillAddrs}
                handleCloseGSTINBillAddrs={handleCloseGSTINBillAddrs}
                selectedGSTINBillAddrs={selectedGSTINBillAddrs}
            />
            <Loading visible={isLoading} />
        </div>
    )
}

export default ViewGSTINs